import { render, staticRenderFns } from "./SidebarHandleAction.vue?vue&type=template&id=88327098&scoped=true&"
import script from "./SidebarHandleAction.vue?vue&type=script&lang=js&"
export * from "./SidebarHandleAction.vue?vue&type=script&lang=js&"
import style0 from "bootstrap/dist/css/bootstrap.min.css?vue&type=style&index=0&id=88327098&prod&scoped=true&lang=css&"
import style1 from "./SidebarHandleAction.vue?vue&type=style&index=1&id=88327098&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88327098",
  null
  
)

export default component.exports